export var getFileUrl = function getFileUrl(file) {
  if (file.substr(0, 4) !== 'http') {
    return "".concat(process.env.NEXT_PUBLIC_SERVER_PUBLIC_URL, "/storage/").concat(file);
  }
  return file;
};